module.exports = __webpack_public_path__ + "img/10.7ca61d07.png";